module.exports = __webpack_public_path__ + "img/whatsapp.6fe49978.png";